var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
__export(exports, {
  UserCardCache: () => UserCardCache
});
class UserCardCache {
  constructor(cache = {}) {
    this.cache = cache;
  }
  getValues() {
    return this.cache;
  }
  setValue(cardId, index) {
    if (!this.keyExists(cardId)) {
      const value = [];
      for (let j = 0; j <= index; j++) {
        value.push(j === index);
      }
      this.cache = __spreadProps(__spreadValues({}, this.cache), {
        [cardId]: {
          type: "card",
          value
        }
      });
      return;
    }
    if (this.isNewValue(cardId, index)) {
      const gaps = index - this.cache[cardId].value.length;
      for (let i = 0; i < gaps; i++) {
        this.cache[cardId].value.push(false);
      }
      this.cache[cardId].value.push(true);
      return;
    }
    this.updateValue(cardId, index);
  }
  deleteValue(cardId, index) {
    if (!this.keyExists(cardId) || this.isNewValue(cardId, index))
      return;
    this.cache[cardId].value.splice(index, 1);
  }
  updateValue(cardId, index) {
    const value = this.cache[cardId].value.map((v, i) => index === i ? true : v);
    this.cache = __spreadProps(__spreadValues({}, this.cache), {
      [cardId]: {
        type: "card",
        value
      }
    });
  }
  keyExists(cardId) {
    if (!this.cache[cardId]) {
      return false;
    }
    return this.cache[cardId].value.length > 0;
  }
  isNewValue(cardId, index) {
    return index >= this.cache[cardId].value.length;
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  UserCardCache
});
